var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isNewStartPage)?_c(_setup.GlobalHomeNew,{on:{"scrollToTop":function($event){return _vm.$emit('scrollToTop')}}}):_c(_setup.GlobalHomeLegacy,{on:{"scrollToTop":function($event){return _vm.$emit('scrollToTop')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }